module.exports = __webpack_public_path__ + "static/media/propellerplan.d8e2b347.png";